const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignReports', ['Application', 'Users', 'Managers', '$q', '$translate', function(Application, Users, Managers, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      showHide: '=',
      manager: '=',
      refresh: '&'
    },
    template: require('../../../templates/directives/manager/assign-reports.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.queryChanged = false;
      self.per_page = 20;
      self.endOfLine = true;
      self.selectionCount = 0;
      var assignList = {
        in: {},
        nin: {},
        queries: [],
        removals: {}
      };
      var queryOptions = {
        linked_locations: 'array',
        linked_departments: 'array',
        $or: 'textMatch',
        role: 'text',
        hired: 'date',
        createdAt: 'date',
        last_login: 'date'
      };

      self.individuals = {};
      var getStandardQuery = function(){
        var q = {
          subresource: '',
          page: 1,
          per_page: self.per_page,
          fields: '_id,first_name,last_name,email,full_name,role,image,linked_departments,linked_locations,job_title,last_login,createdAt,hired,manager_email',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name'
        };
        if ($scope.manager && $scope.manager.email) {
          q.email = '$ne,' + $scope.manager.email;
          self.restrictions.email = '$ne,' + $scope.manager.email;
        }

        return q;
      };

      self.query = getStandardQuery();

      self.initialize = function () {
        self.load();
      };

      self.load = function () {
        self.disableScroll = true;
        Users.find(self.query, function (users) {
          if (users.length < self.per_page) {
            self.endOfLine = true;
          }
          if (self.query.page === 1 || !self.users) {
            self.users = users;
          } else {
            self.users = self.users.concat(users);
          }
          if (!self.endOfLine) {
            self.disableScroll = false;
          }
        }, function (error) {
          console.log('Error getting users:', error);
        });
      };
      self.nextPage = function() {
        self.query.page++;
        self.load();
      };
      self.onQuery = function(opts) {
        self.endOfLine = false;
        self.query = getStandardQuery();
        if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
          self.queryChanged = false;
          self.load();
          return;
        }
        self.queryChanged = true;
        self.query.page = 1;
        for (var key in opts) {
          self.query[key] = opts[key];
        }

        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };

      self.preview = {
        page: 1,
        show: false,
        additions: [],
        removals: [],
        getUsers: function() {
          var items = {};
          var removals = Object.keys(assignList.removals);
          items.queries = assignList.queries;
          items.in = Object.keys(assignList.in);
          items.nin = Object.keys(assignList.nin);

          self.preview.show = true;
          var segList = Users.segmentationList({
            fields: '_id,first_name,last_name,email,image,full_name,job_title,linked_locations,linked_departments,role,hired,createdAt,last_login,manager_email',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            email: '$ne,' + $scope.manager.email,
            page: self.preview.page,
            per_page: self.per_page
          }, items).$promise;

          var removeList = Users.find({
            _id: '$in,' + removals.length + ',' + removals.join(','),
            fields: '_id,first_name,last_name,email,image,full_name,job_title,linked_locations,linked_departments,role,hired,createdAt,last_login,manager_email',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            page: self.preview.page,
            per_page: self.per_page
          }).$promise;

          var promises = [segList, removeList];

          $q.all(promises).then(function(results) {
            self.preview.additions = results[0];
            self.preview.removals = results[1];
            self.preview.active = self.preview.additions.length ? 'additions' : 'removals';
          });
        },
        nextPage: function() {
          self.preview.page++;
          self.preview.getUsers();
        },
        previousPage: function() {
          if (self.preview.page) {
            self.preview.page--;
            self.preview.getUsers();
          }
        },
        confirmed: function() {
          var body = {
            email: $scope.manager.email,
            assignees: {},
            removals: Object.keys(assignList.removals)
          };

          body.assignees.queries = assignList.queries;
          body.assignees.in = Object.keys(assignList.in);
          body.assignees.nin = Object.keys(assignList.nin);

          Managers.queryUpdate({}, body).$promise
          .then(function(results) {
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'All changes were successful'});
            self.preview.show = false;
            $scope.showHide = false;
            self.clearChoices();
            $scope.refresh();
          });
        }
      };

      // Functions for selecting and deselecting users to assign
      self.selection = {
        userClick: function(user) {
          if (user.manager_email === $scope.manager.email) {
            if (assignList.removals[user._id]) {
              delete assignList.removals[user._id];
            } else {
              assignList.removals[user._id] = true;
            }
            this.getCount();
            return;
          }

          if (this.isUserChecked(user)) {
            this.uncheckUser(user);
            return;
          }
          this.checkUser(user);
        },
        isUserChecked: function(user) {
          if (user.manager_email === $scope.manager.email) {
            if (assignList.removals[user._id]) {
              self.individuals[user._id] = false;
              return false;
            }
            self.individuals[user._id] = true;
            return true;
          }
          if (assignList.in[user._id]) {
            self.individuals[user._id] = true;
            return true;
          }
          if (assignList.nin[user._id]) {
            self.individuals[user._id] = false;
            return false;
          }

          return self.checkQueries(user);
        },
        uncheckUser: function(user, id) {
          id = id ? id : user._id;
          if (assignList.in[id]) {
            delete assignList.in[id];
          }
          assignList.nin[id] = true;
          this.getCount();
        },
        checkUser: function(user, id) {
          id = id ? id : user._id;
          if (assignList.nin[id]) {
            delete assignList.nin[id];
          }
          assignList.in[id] = true;
          this.getCount();
        },
        selectAll: function() {
          var queryAddition = {};
          if (self.query._id) {
            self.selection.checkUser(null, self.query._id);
            return;
          }
          for (var key in queryOptions) {
            if (self.query[key]) {
              queryAddition[key] = self.query[key];
            }
          }
          assignList.queries.push(queryAddition);
          this.getCount();
        },
        getCount: function() {
          var items = {};
          var removalsCount = Object.keys(assignList.removals).length;
          items.queries = assignList.queries;
          items.in = Object.keys(assignList.in);
          items.nin = Object.keys(assignList.nin);

          Users.segmentationCount({}, items).$promise
          .then(function(count) {
            self.selectionCount = count.count ? count.count : 0;
            self.selectionCount += removalsCount;
            self.queryChanged = false;
          });
        }
      };

      self.checkQueries = function(user) {
        if (!assignList.queries || !assignList.queries.length) {
          self.individuals[user._id] = false;
          return false;
        }
        for (var i = 0; i < assignList.queries.length; i++) {
          var current = assignList.queries[i];
          var currentFailed = false;
          for (var key in queryOptions) {
            if (current[key]) {
              if (!self.fieldCheck(user, key, current[key])) {
                currentFailed = true;
                break;
              }
            }
          }
          if (!currentFailed) {
            self.individuals[user._id] = true;
            return true;
          }
        }
        self.individuals[user._id] = false;
        return false;
      };

      self.fieldCheck = function(user, field, option) {
        var text;
        if (!field || typeof field !== 'string') {
          return false;
        }

        switch (field) {
          case 'linked_locations':
            if (!user.linked_locations || !user.linked_locations[0] || !user.linked_locations[0]._id || option.indexOf(user.linked_locations[0]._id) === -1) {
              return false;
            }
            return true;
            break;
          case 'linked_departments':
            if (!user.linked_departments || !user.linked_departments[0] || !user.linked_departments[0]._id || option.indexOf(user.linked_departments[0]._id) === -1) {
              return false;
            }
            return true;
            break;
          case '$or':
            text = option.split(',')[4];
            if (user.full_name && user.full_name.indexOf(text) !== -1 || user.email && user.email.indexOf(text) !== -1 || user.job_title && user.job_title.indexOf(text) !== -1) {
              return true;
            }
            return false
            break;
          case 'role':
            if (user.role && user.role === option) {
              return true;
            }
            return false;
            break;
          case 'hired':
            text = new Date(option.slice(10));
            if (user.hired && new Date(user.hired) > text) {
              return true;
            }
            return false;
            break;
          case 'createdAt':
            text = new Date(option.slice(10));
            if (user.createdAt && new Date(user.createdAt) > text) {
              return true;
            }
            return false;
            break;
          case 'last_login':
            text = new Date(option.slice(10));
            if (user.last_login && new Date(user.last_login) > text) {
              return true;
            }
            return false;
            break;
          default:
            return false;
            break;
        }
      };


      // End functions for selecting and deselecting users to assign
      self.clearChoices = function() {
        assignList = {
          in: {},
          nin: {},
          removals: {},
          queries: []
        };
        self.individuals = {};
        self.selectionCount = 0;
        self.queryChanged = false;
        self.clearQuery = true;
      };
      self.cancel = function() {
        $scope.showHide = false;
        self.clearChoices();
      };
      self.restrictions = {

      };
      self.resizeWindow = function() {
        self.windowHeight = $window.innerHeight - (document.querySelector('#scroll-selection').clientHeight);
      };
      angular.element($window).bind('resize', function() {
        self.resizeWindow();
        $scope.$apply();
      });
      $scope.$on('$destroy', function () {
        angular.element($window).unbind('resize');
      });
      $scope.$watch('showHide', function(newVal, oldVal) {
        var init = false;
        if (newVal && !oldVal) {
          if (!init) {
            self.query = getStandardQuery();
            self.initialize();
            init = true;
          }
          setTimeout(function() {
            // settimeout is necessary to take affect after elements have been resized
            self.resizeWindow();
            $scope.$apply();
          }, 100);
        }
      });

      $translate(['manage.assign.content_confirmMessage']).then(function(results){

        self.translations = results;
      });

    }],
    controllerAs: 'assignments'
  };
}]);
